import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconReplay30$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconReplay30 extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: 'b0c4480a9e77107d7c113f439a29a9627e302ebf', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: 'a83be60cc54c793051318a5ec2622a048a99f0ae', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: 'ceeecffc1bdee09f9f67d4e76a4495699c8631d0', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M9 6.472h4.628a5.11 5.11 0 0 1 5.162 4.824 4.85 4.85 0 0 1-1.362 3.562 5 5 0 0 1-2.841 1.493.51.51 0 0 1-.587-.5v-.532a.51.51 0 0 1 .425-.493c.73-.137 1.4-.49 1.926-1.015a3.32 3.32 0 0 0 .939-2.473 3.6 3.6 0 0 0-3.662-3.362H9v2.3a.5.5 0 0 1-.854.352L5.114 7.576a.5.5 0 0 1 0-.706l3.033-3.024A.5.5 0 0 1 9 4.2zm-.228 7.995V15.7a1.507 1.507 0 0 0 1.628 1.57 1.5 1.5 0 0 0 1.621-1.57v-1.229A1.505 1.505 0 0 0 10.4 12.9a1.507 1.507 0 0 0-1.628 1.567M8.355 16c0 .752-.66 1.266-1.586 1.266A1.424 1.424 0 0 1 5.2 16a.2.2 0 0 1 .2-.247h.7a.26.26 0 0 1 .238.183.424.424 0 0 0 .816-.119c0-.229-.156-.367-.431-.367h-.146a.25.25 0 0 1-.257-.25v-.33a.25.25 0 0 1 .257-.257h.128c.266 0 .422-.119.422-.339s-.156-.349-.4-.349a.38.38 0 0 0-.385.239c-.037.1-.13.17-.238.174h-.692a.2.2 0 0 1-.2-.248 1.46 1.46 0 0 1 1.576-1.19c.889 0 1.485.486 1.485 1.211a.97.97 0 0 1-.559.926c.391.16.645.54.641.963m2.469-1.508v1.183c0 .349-.137.531-.425.531s-.431-.187-.431-.531v-1.183c0-.344.149-.532.431-.532s.425.182.425.532", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-replay-30", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-replay-30"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-replay-30":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconReplay30$1);
            }
            break;
    } });
}

const CosmosIconReplay30 = CosmosIconReplay30$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconReplay30, defineCustomElement };
